import ActionCable from 'actioncable';
import { Effect } from 'redux-saga/effects';

import {
  eventChannel,
} from 'redux-saga';
import * as eff from 'redux-saga/effects';

import {
  coreActions,
  coreSelectors,
} from '@gymcloud/core';

import config from 'web-config';

const cableChannel = ({
  cable,
  channel,
  room,
}: {
  cable: any,
  room?: string,
  channel: string,
}) => eventChannel(
  received => {
    const subscription = cable.subscriptions.create({ channel, room }, { received });

    return () => {
      cable.subscriptions.remove(subscription);
    };
  },
);

function* messages({ message }: any): Generator<Effect, void, any> {
  const unread = yield eff.select(
    coreSelectors.getResourceMeta('conversations', 'unread'),
  );
  const conversation = yield eff.select(
    coreSelectors.getResourceById('conversations', message.conversation_id),
  );

  if (!conversation) {
    yield eff.put(
      coreActions.requestConversationList(),
    );
  } else {
    // remove old
    yield eff.put(
      coreActions.deleteResources({
        resourceType: 'conversations',
        resources: [conversation],
      }),
    );
    yield eff.put(
      coreActions.addResources({
        resourceType: 'conversations',
        resources: [{
          ...conversation,
          updated_at: message.updated_at,
          last_message: {
            ...conversation.last_message,
            body: message.body,
            message_category: message.message_category,
          },
        }],
      }),
    );
  }

  yield eff.put(
    coreActions.requestUnreadCategories({
      id: message.conversation_id,
    }),
  );

  yield eff.put(
    coreActions.addResources({
      list: `${message.conversation_id}_${message.message_category}`,
      resources: [message],
      resourceType: 'messages',
    }),
  );

  yield eff.put({
    type: coreActions.resourceActionTypes.UPDATE_RESOURCES,
    meta: {
      conversations: {
        unread: {
          count: unread.count + 1,
        },
      },
    },
  });
}

function* vimeoUpload(result: any) {
  yield eff.put(
    coreActions.updateResources({
      resources: [result],
      resourceType: 'videos',
    }),
  );
}

function* userSettings(result: any) {
  yield eff.put(
    coreActions.setProfileState({
      user_settings: result,
    }),
  );
}

export default function* cableFlow({
  accessToken,
}: {
  accessToken: string,
}): Generator<Effect, void, any> {
  const cable = ActionCable.createConsumer(`${config.wsUrl}?${accessToken}`);

  const messagesChannel = yield eff.call(
    cableChannel,
    {
      cable,
      channel: 'MessagesChannel',
    },
  );

  const vimeoUploadChannel = yield eff.call(
    cableChannel,
    {
      cable,
      channel: 'VimeoUploadChannel',
    },
  );

  const userSettingsChannel = yield eff.call(
    cableChannel,
    {
      cable,
      channel: 'UserSettingsChannel',
    },
  );

  yield eff.takeEvery(messagesChannel, messages);
  yield eff.takeEvery(vimeoUploadChannel, vimeoUpload);
  yield eff.takeEvery(userSettingsChannel, userSettings);
}
